import { Component, Vue, Prop } from 'vue-property-decorator';
import ValidationService from '../../Services/ValidationService';
import { Inject } from 'vue-di-container';
import WithRender from './Payment.html';
import PaymentService from './PaymentService';
import { PaymentModel } from './PaymentModel';
import MainPaymentComponents from '../MainPaymentComponents/MainPaymentComponents';
import { Toaster } from '../../Services/toast';
import MainPaymentService from '../MainPaymentComponents/MainPaymentService';
import { ProviderInvoiceInfoModel } from './ProviderInvoiceInfoModel';
import UserService from '../../shared/userService/UserService';
import { HyperPayModel } from './HyperPayModel';
import {
    clearRenewalToast,
    clearRenewalPaymentRedirectMark,
    getRouteFromRenewalSource,
    getRouteNameFromPaymentReturnTarget,
    parseRenewalTemplateRequestIds,
    parseSenderRenewalRouteIds,
    peekPaymentReturnTarget,
    setRenewalDashboardSuccessToastPending,
    takePaymentReturnTarget,
    takeTemplateRenewalsPendingToast,
} from '../../constants/renewalPaymentRedirect';
import RenewRegisterSenderService from '../Dashboard/ExtendDurationRequests/RenewRegisterSender/RenewRegisterSenderService';
import MessageTemplateRenewalService from '../MessageTemplateDashboard/MessageTemplateRenewal/MessageTemplateRenewalService';
import { translateTemplateRenewalMessage } from '../MessageTemplateDashboard/MessageTemplateRenewal/templateRenewalMessages';

@WithRender
@Component({
    components: {
        MainPaymentComponents,
    },
    diProvide: [
        PaymentService,
        MainPaymentService,
        UserService,
        RenewRegisterSenderService,
        MessageTemplateRenewalService,
    ],
})
export default class Payment extends Vue {
    public providerInvoiceInfo: ProviderInvoiceInfoModel = {
        country: '',
        city: '',
        district: '',
        streetName: '',
        buildingNumber: '',
        postalCode: '',
        vatNumber: '',
        additionalNumber: '',
        otherIdentifier: '',
    };
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(PaymentService) public paymentService!: PaymentService;
    @Inject(MainPaymentService) public mainPaymentService!: MainPaymentService;
    @Inject(UserService) public userService!: UserService;
    @Inject(RenewRegisterSenderService) public renewRegisterSenderService!: RenewRegisterSenderService;
    @Inject(MessageTemplateRenewalService) public messageTemplateRenewalService!: MessageTemplateRenewalService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;
    @Prop({ type: Boolean, default: false })
    public isFromDashboard: boolean | any;
    public phoneNumber: string = '';
    public disclaimerChecked: boolean = false;
    public ids: string | any;
    public idsList: string[] = [];
    public sendersPaymentSummery: PaymentModel = {} as PaymentModel;
    public payfortModel: any;
    public expiryDate = new Date().toISOString().substr(0, 7);
    public cardNumber: string = '';
    public cVV: string = '';
    public cardHolderName: string = '';
    public exDate: string = '';
    public fellproviderinfodialog: boolean = false;
    public isCreatePaymentLinkOption: boolean = false;
    public urlString: string = '';
    public showPaymentOptions: boolean = true;
    public isMada: boolean = false;
    public showPaymentLink: boolean = false;
    public User: any;
    public providerId: string = '';
    public paymentOptions: number = 0;
    public balanceAmount: number = 0;
    public isCreditLimitOptionValid: boolean = false;
    public checkoutId: string = '';
    public hyperPayModel: HyperPayModel = {} as HyperPayModel;
    public shopperResultUrl: string = '';
    public dataBrand: string = '';
        /** Sender renewal (/RenewRegisterSender) navigates with query fromRenewal */
    public isRenewalFlow: boolean = false;
    public isMessageTemplateFlow: boolean = false;
    public renewalSourceQuery: string = '';
    /** Sender GUIDs for RenewRegisterSender after Back (distinct from `ids` used by payment-transaction API after Pay-now). */
    public renewalSenderIdsQuery: string = '';
    /** True until extend rows are created at Submit (RenewRegisterSender Pay now flow only). */
    public renewPayNowDeferred: boolean = false;
    public deferredExtendCreateInFlight: boolean = false;
    /** Template renewals selected in RenewRegisterSender are paid together with the sender extension. */
    public hasRenewalTemplates: boolean = false;
    public deferredTemplateRenewalsPending: boolean = false;
    public templateRenewalRequestIds: string[] = [];
    public $refs!: {

        payfortForm: HTMLFormElement,

        paymentMethod: HTMLFormElement,
    };
    public nameRules = [
        (v: any) => !!v || this.$t('sheared.itemisRequired'),
    ];
    public rulesExpiryDate = [
        (v: any) => v!! || this.$t('sheared.itemisRequired'),
    ];
    public paymentMethoditems = [
        { paymentMethodValue: 'VISA', paymentMethodName: 'VISA' },
        { paymentMethodValue: 'MASTERCARD', paymentMethodName: 'MASTERCARD' },
    ];
    public async mounted() {
        this.isCreatePaymentLinkOption = false;
        const fromRenewal = this.$route.query.fromRenewal === '1';
        const rs = this.$route.query.renewalSource;
        this.renewalSourceQuery = typeof rs === 'string' ? rs : '';
        this.isRenewalFlow = fromRenewal
            || this.renewalSourceQuery === 'extendDuration'
            || this.renewalSourceQuery === 'senderDashboard'
            || this.renewalSourceQuery === 'contractDashboard';
        const paymentReturnTarget = peekPaymentReturnTarget();
        this.isMessageTemplateFlow = this.$route.query.fromMessageTemplate === '1'
            || paymentReturnTarget === 'messageTemplate'
            || paymentReturnTarget === 'templateRenewal'
            || localStorage.getItem('paymentSource') === 'messageTemplate';
        const rSid = this.$route.query.renewalSenderIds;
        this.renewalSenderIdsQuery = typeof rSid === 'string' ? rSid : '';
        const renewDeferred = fromRenewal && this.$route.query.renewPayNowDeferred === '1';
        this.renewPayNowDeferred = renewDeferred && !!this.renewalSenderIdsQuery;
        const renewalTemplateRequestIds = parseRenewalTemplateRequestIds(this.$route.query as any);
        this.hasRenewalTemplates = this.renewPayNowDeferred && renewalTemplateRequestIds.length > 0;
        const deferredRenewalPayEntry = fromRenewal
            && this.$route.query.renewPayNowDeferred === '1'
            && this.renewalSenderIdsQuery.trim().length > 0;
        if (!deferredRenewalPayEntry) {
            clearRenewalToast();
        }
        this.$emit('childinit', this.layoutSup);
        const idsCombined = parseSenderRenewalRouteIds(this.$route as any);
        this.ids = idsCombined != null ? idsCombined : '';
        this.idsList = [];
        if (this.ids) {
            if (this.ids.includes(',')) {
                this.idsList = this.ids.split(',');
            } else {
                this.idsList.push(this.ids);
            }
        }
        if (this.renewPayNowDeferred && this.renewalSenderIdsQuery) {
            const durRaw = this.$route.query.renewalDuration;
            const duration = typeof durRaw === 'string' ? parseInt(durRaw, 10) : 0;
            const operatorsRaw = this.$route.query.renewalOperators;
            const operatorsStr = typeof operatorsRaw === 'string' ? operatorsRaw : '';
            const previewResp = await this.paymentService.PreviewExtendRenewalPayment({
                senderIds: this.renewalSenderIdsQuery.split(',').map((s) => s.trim()).filter((x) => x.length > 0),
                duration: duration || 0,
                isAutoActivation: this.$route.query.renewalAutoActivation === '1',
                operators: operatorsStr.length ? operatorsStr.split(',').filter(Boolean) : [],
                templateRequestIds: this.hasRenewalTemplates ? renewalTemplateRequestIds : [],
            });
            if (previewResp && previewResp.isSuccess && previewResp.result) {
                this.sendersPaymentSummery = previewResp.result;
                if (typeof this.sendersPaymentSummery.total !== 'string') {
                    this.sendersPaymentSummery.total = String(this.sendersPaymentSummery.total);
                }
            } else {
                Toaster.error(
                    (previewResp && previewResp.errorMessage)
                        || this.$t('shared.errorOccurred').toString(),
                );
                await this.$router.replace(getRouteFromRenewalSource(this.renewalSourceQuery || undefined));
            }
        } else {
            const response = await this.paymentService.Get(this.idsList);
            if (response.isSuccess) {
                this.sendersPaymentSummery = response.result;
            } else {
                Toaster.error(this.getPaymentErrorText(response && response.errorMessage));
                if (this.isRenewalFlow) {
                    await this.$router.replace(getRouteFromRenewalSource(this.renewalSourceQuery || undefined));
                }
            }
        }
        this.User = await this.userService.getUser();
        this.providerId = this.User.details.ProviderId;
        const balanceResponse = await this.paymentService.GetProviderBalance(this.providerId);
        this.balanceAmount = balanceResponse.result;
        const total = parseFloat(this.sendersPaymentSummery.total);
        this.isCreditLimitOptionValid = this.balanceAmount >= total;
        const userProviderhasVatNumber = await this.paymentService.providerHasVatNumber();
        if (userProviderhasVatNumber.isSuccess) {
            if (userProviderhasVatNumber.result === false) {
                await this.showfellproviderinfodialog();
                const infoResponse = await this.paymentService.getProviderNewInfo();
                this.providerInvoiceInfo = infoResponse.result;
            } else {
                await this.hidefellproviderinfodialog();
            }
        } else {
            Toaster.error(userProviderhasVatNumber.errorMessage);
        }
    }
    public async showfellproviderinfodialog() {
        this.fellproviderinfodialog = true;
    }
    public async hidefellproviderinfodialog() {
        this.fellproviderinfodialog = false;
    }
    public async hideOtherPaymentOptions() {
        this.showPaymentLink = false;
    }
    public isNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (isNaN(paste)) {
            ev.preventDefault();
        }
    }
    public async PayfortSubmit(event: any) {
        if (this.$refs.payfortForm.validate()) {
            const key = 'expiry_date';
            event.target.elements[key].value = this.GetExpireDate();
            const keyHolderName = 'card_holder_name';
            event.target.elements[keyHolderName].value = this.cardHolderName;
            const keyNumber = 'card_number';
            event.target.elements[keyNumber].value = this.cardNumber;
            const keycVV = 'card_security_code';
            event.target.elements[keycVV].value = this.cVV;
            event.target.action = this.payfortModel.GatewayUrl;
            event.target.submit();
        }
    }
    public GetExpireDate() {
        const date = this.expiryDate.split('-');
        const year = date[0].substr(2);
        const month = date[1];
        return year + month;
    }
    public isNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();
        }
    }
    public isVatNumberPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (!/^[0-9]+$/.test(paste)) {
            ev.preventDefault();
        }
    }
    public isDateField(val: KeyboardEvent) {
        if (!this.validationService.isDate(val.key)) {
            val.preventDefault();
        }
    }
    public updateValueCardNumber(e: any) {
        this.cardNumber = e.target.value.replace(/ /g, '');
    }
    public updateValueExDate(e: any) {
        this.exDate = e.target.value.replace(/\//g, '', '');
    }
    public get isValid(): boolean {
        return (this.expiryDate !== ''
            && this.expiryDate.includes('-')
            && this.cardNumber !== ''
            && this.cVV !== ''
            && this.cardHolderName !== '');
    }
    public get vatNumberIsValid(): boolean {
        return this.validationService.isValidVatNumber(this.providerInvoiceInfo.vatNumber);
    }
    public async updateProvider() {
        if (this.providerInvoiceInfo.vatNumber !== '') {
            this.fellproviderinfodialog = false;
            const response = await this.paymentService.editProviderNewInfo(this.providerInvoiceInfo);
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            } else {
                Toaster.success(this.$t('shared.editProviderSuccessfully').toString());
                this.hidefellproviderinfodialog();
            }
        }
    }
    public async redirectToDashboard() {
        this.fellproviderinfodialog = false;
        this.$router.push({ name: this.resolvePaymentReturnRouteName() });
    }

    private resolvePaymentReturnRouteName(): string {
        const target = takePaymentReturnTarget();
        if (target != null) {
            return getRouteNameFromPaymentReturnTarget(target);
        }
        localStorage.removeItem('paymentSource');
        if (this.isMessageTemplateFlow || this.$route.query.fromMessageTemplate === '1') {
            return 'MessageTemplateDashboard';
        }
        return 'Dashboard';
    }

    /** Create extend SenderRequest rows when Pay now was deferred until Submit (renewal flow only). */
    private async ensureDeferredExtendRequestCreated(): Promise<boolean> {
        if (this.deferredTemplateRenewalsPending) {
            return this.createDeferredTemplateRenewals();
        }
        if (!this.renewPayNowDeferred || !this.renewalSenderIdsQuery) {
            return true;
        }
        if (this.idsList.length > 0) {
            return true;
        }
        if (this.deferredExtendCreateInFlight) {
            return false;
        }
        this.deferredExtendCreateInFlight = true;
        try {
            const durRaw = this.$route.query.renewalDuration;
            const duration = typeof durRaw === 'string' ? parseInt(durRaw, 10) : 0;
            const operatorsRaw = this.$route.query.renewalOperators;
            const response = await this.renewRegisterSenderService.AddExtendRequest({
                senderIds: this.renewalSenderIdsQuery.split(',').map((s) => s.trim()).filter((x) => x.length > 0),
                duration: duration || 0,
                isAutoActivation: this.$route.query.renewalAutoActivation === '1',
                operators: typeof operatorsRaw === 'string' && operatorsRaw.length
                    ? operatorsRaw.split(',').filter(Boolean)
                    : [],
            });
            if (!response || !response.isSuccess) {
                Toaster.error(
                    (response && response.errorMessage) || this.$t('shared.errorOccurred').toString(),
                );
                return false;
            }
            const raw = response.result && response.result.ids;
            if (!raw || !(raw as string[]).length) {
                Toaster.error(this.$t('shared.errorOccurred').toString());
                return false;
            }
            const idsJoined = (raw as string[]).map((id) => String(id)).join(',');
            this.ids = idsJoined;
            this.idsList = idsJoined.includes(',') ? idsJoined.split(',') : [idsJoined];
            this.renewPayNowDeferred = false;
            setRenewalDashboardSuccessToastPending();
            Toaster.success(this.$t('shared.senderRenewalRequestCreatedPendingPayment').toString());
            if (!this.hasRenewalTemplates) {
                return true;
            }
            this.deferredTemplateRenewalsPending = true;
            return await this.createDeferredTemplateRenewals();
        } finally {
            this.deferredExtendCreateInFlight = false;
        }
    }

    /** Template renewals are created after the extension so the backend caps them at the projected sender expiry. */
    private async createDeferredTemplateRenewals(): Promise<boolean> {
        const templateRequestIds = parseRenewalTemplateRequestIds(this.$route.query as any);
        const response = await this.messageTemplateRenewalService.Renew(templateRequestIds, true);
        if (!response || !response.isSuccess || !response.result) {
            Toaster.error(this.getPaymentErrorText(response && response.errorMessage));
            return false;
        }
        this.deferredTemplateRenewalsPending = false;
        this.templateRenewalRequestIds = (response.result as string[]).map((id) => String(id));
        this.idsList = this.idsList.concat(this.templateRenewalRequestIds);
        return this.refreshPaymentSummary();
    }

    private async refreshPaymentSummary(): Promise<boolean> {
        const response = await this.paymentService.Get(this.idsList);
        if (!response || !response.isSuccess) {
            Toaster.error(this.getPaymentErrorText(response && response.errorMessage));
            return false;
        }
        this.sendersPaymentSummery = response.result;
        return true;
    }

    private get extendRequestIds(): string[] {
        return this.idsList.filter((id) => this.templateRenewalRequestIds.indexOf(id) < 0);
    }

    private getPaymentErrorText(errorMessage: string | undefined): string {
        if (!errorMessage) {
            return this.$t('shared.errorOccurred').toString();
        }
        const translated = translateTemplateRenewalMessage(errorMessage, (key: string) => this.$t(key).toString());
        return translated !== null ? translated : errorMessage;
    }

    /** Return to sender renewal without paying; clears post-payment marker so stray redirects do not trigger */
    public backToRenewal() {
        clearRenewalPaymentRedirectMark();
        if (this.renewalSourceQuery === 'extendDuration' && !this.renewalSenderIdsQuery) {
            this.$router.push({ name: 'ExtendDurationRequests' });
            return;
        }
        const query: Record<string, string> = {};
        if (this.renewalSourceQuery) {
            query.renewalSource = this.renewalSourceQuery;
        }
        if (this.renewalSenderIdsQuery) {
            query.renewalSenderIds = this.renewalSenderIdsQuery;
        }
        if (this.ids) {
            query.ids = String(this.ids);
        }
        const rd = this.$route.query.renewalDuration;
        if (typeof rd === 'string' && rd.length) {
            query.renewalDuration = rd;
        }
        const ra = this.$route.query.renewalAutoActivation;
        if (typeof ra === 'string' && ra.length) {
            query.renewalAutoActivation = ra;
        }
        const ro = this.$route.query.renewalOperators;
        if (typeof ro === 'string' && ro.length) {
            query.renewalOperators = ro;
        }
        const rt = this.$route.query.renewalTemplateRequestIds;
        if (typeof rt === 'string' && rt.length) {
            query.renewalTemplateRequestIds = rt;
        }
        this.$router.push({
            name: 'RenewRegisterSender',
            query,
        });
    }
    public async createPaymentLinkClicked(): Promise<string> {
        this.urlString = window.location.origin + '/PublicPayment?ids=' + this.idsList + '&IsMada=' + this.isMada;
        return this.urlString;
    }
    public async copyURL() {
        await navigator.clipboard.writeText(this.urlString);
    }
    public get isOptionChooseValid(): boolean {
        return (this.paymentOptions > 0);
    }
    public async GotoPaymentOption() {
        const extendReady = await this.ensureDeferredExtendRequestCreated();
        if (!extendReady) {
            return;
        }
        if (this.paymentOptions.toString() === '1') {
            this.showPaymentOptions = false;
            this.isMada = false;
            const getHyperPayModelResponse = await this.paymentService.GetHyperPayModel
                (this.sendersPaymentSummery.total, this.isMada);
            if (getHyperPayModelResponse.isSuccess) {
                this.hyperPayModel = getHyperPayModelResponse.result;
                this.checkoutId = this.hyperPayModel.id;
                this.shopperResultUrl = this.hyperPayModel.shopperResultUrl;
                const addPaymentTransactionResponse = await this.paymentService.AddPaymentTransaction
                    (this.idsList, this.checkoutId, this.isMada);
                if (!addPaymentTransactionResponse || !addPaymentTransactionResponse.isSuccess) {
                    Toaster.error(this.getPaymentErrorText(
                        addPaymentTransactionResponse && addPaymentTransactionResponse.errorMessage));
                    this.showTemplateRenewalsPendingToast();
                    return;
                }
                const script = document.createElement('script');
                script.setAttribute('src', this.sendersPaymentSummery.hyperPayUrl + this.checkoutId);
                const container = document.getElementById('hyperPaycontainer');
                container!.appendChild(script);
            }

        } else if (this.paymentOptions.toString() === '2') {
            this.showPaymentOptions = false;
            this.isMada = true;
            const getHyperPayModelResponse = await this.paymentService.GetHyperPayModel
                (this.sendersPaymentSummery.total, this.isMada);
            if (getHyperPayModelResponse.isSuccess) {
                this.hyperPayModel = getHyperPayModelResponse.result;
                this.checkoutId = this.hyperPayModel.id;
                this.shopperResultUrl = this.hyperPayModel.shopperResultUrl;
                const addPaymentTransactionResponse = await this.paymentService.AddPaymentTransaction
                    (this.idsList, this.checkoutId, this.isMada);
                if (!addPaymentTransactionResponse || !addPaymentTransactionResponse.isSuccess) {
                    Toaster.error(this.getPaymentErrorText(
                        addPaymentTransactionResponse && addPaymentTransactionResponse.errorMessage));
                    this.showTemplateRenewalsPendingToast();
                    return;
                }
                const script = document.createElement('script');
                script.setAttribute('src', this.sendersPaymentSummery.hyperPayUrl + this.checkoutId);
                const container = document.getElementById('hyperPaycontainer');
                container!.appendChild(script);
            }
        } else if (this.paymentOptions.toString() === '3') {
            const addPaymentTransactionResponse = await this.paymentService.AddPaymentTransaction
                (this.idsList, this.checkoutId, this.isMada);
            if (addPaymentTransactionResponse.isSuccess) {
                const response = await this.paymentService.SetCreditLimitTransactionAsPaid
                    (addPaymentTransactionResponse.result.paymentTransactionIds,
                        addPaymentTransactionResponse.result.paymentIdentifier);
                if (response.isSuccess) {
                    clearRenewalPaymentRedirectMark();
                    if (this.isRenewalFlow) {
                        Toaster.success(this.$t('shared.senderRenewalRequestAddedSuccessfully').toString());
                    } else {
                        Toaster.success(this.$t('shared.paidSuccessfully').toString());
                    }
                    this.showTemplateRenewalsPendingToast();
                    await this.$router.push({ name: this.resolvePaymentReturnRouteName() });
                    await this.paymentService.payRequestEmail(this.extendRequestIds);
                } else {
                    Toaster.error(response.errorMessage);
                    this.showTemplateRenewalsPendingToast();
                }
            } else {
                Toaster.error(this.getPaymentErrorText(addPaymentTransactionResponse.errorMessage));
                this.showTemplateRenewalsPendingToast();
            }
        } else if (this.paymentOptions.toString() === '4') {
            this.isMada = false;
            this.showPaymentLink = true;
            this.isCreatePaymentLinkOption = true;
            this.createPaymentLinkClicked();
            this.showTemplateRenewalsPendingToast();
        } else if (this.paymentOptions.toString() === '5') {
            this.isMada = true;
            this.showPaymentLink = true;
            this.isCreatePaymentLinkOption = true;
            this.createPaymentLinkClicked();
            this.showTemplateRenewalsPendingToast();
        }
    }

    private showTemplateRenewalsPendingToast() {
        if (takeTemplateRenewalsPendingToast()) {
            Toaster.success(this.$t('shared.templateRenewalsPendingPayment').toString());
        }
    }
    public isMobileNumberValid() {
        if (!this.phoneNumber.startsWith('5')) {
            Toaster.error(this.$t('shared.InvalidMobileNumber').toString());
        }
    }
    
    public get isValidPhoneNumber(): boolean {
        return (
            this.phoneNumber.trim() !== ''
            && this.phoneNumber.trim().length === 9
            && this.phoneNumber.startsWith('5')

        );
    }
}